import * as React from 'react'
import { OfficeInstance } from '../../../models/Office'
import { css, styled } from '../../../shared/styled-components'
import { Utils } from '../../../shared/Utils'

interface IProps {
  office?: OfficeInstance
  horizontal?: boolean
}

export const OfficeListItemButtons = ({ office, horizontal }: IProps) => {
  return (
    <Buttons {...{ horizontal }}>
      <PhoneButton>
        <PhoneNumber>{office.phone}</PhoneNumber>
        {office.phone.indexOf('0800') === 0 && <PhoneInfo>Kostenlose Hotline</PhoneInfo>}
      </PhoneButton>
      {office.drFlexId ? (
        <BookingButton onClick={() => (window as any).toggleDrFlexAppointments?.(office.drFlexId)}>
          online Termin buchen
        </BookingButton>
      ) : (
        <BookingButton as="a" href={office.bookingUrl}>
          online Termin buchen
        </BookingButton>
      )}
    </Buttons>
  )
}

const Buttons = styled.div<{ horizontal?: boolean }>`
  display: flex;
  flex-direction: ${(props) => (props.horizontal ? 'row' : 'column')};
  flex: 1;
  color: ${(props) => props.theme.blueColor};
  align-items: start;
  justify-content: start;
  padding-left: 30px;
  padding-top: 30px;
  @media (max-width: 600px) {
    padding-left: 0;
    padding-top: 0;
    margin-top: 53px;
  }
`

const ButtonStyles = css`
  cursor: pointer;
  width: 16rem;
  height: 3rem;
  @media (max-width: 950px) {
    width: 240px;
  }
  @media (max-width: 600px) {
    width: 95%;
  }
`

const PhoneButton = styled.div`
  ${ButtonStyles};
  display: flex;
  flex-direction: column;
  background: lightgrey;
  margin-bottom: 1rem;
  background: rgba(58, 80, 107, 1)
    url('${Utils.getAssetPath('/assets/calculator/result/phone.svg')}') no-repeat 10px center;
  background-size: 30px;
  padding: 8px 5px 5px 4rem;
  border-radius: 5px;
  color: white;
  &:before {
    content: "kostenlose Hotline";
    font-size: 11px;
    margin-top: -3px;
     @media (max-width: 600px) {
     display: none;
    }
  }
  @media (max-width: 600px) {
    background-size: 20px;
    background-position: 3px center;
    height: 36px;
    background-color: ${(props) => props.theme.greenColor};
    padding: 10px 5px 5px 4px;
    border-radius: 0px 5px 5px 0;
    margin-bottom: 5px;
    }
   @media print { 
  -webkit-print-color-adjust: exact !important;   /* Chrome, Safari 6 – 15.3, Edge */
    color-adjust: exact !important;                 /* Firefox 48 – 96 */
    print-color-adjust: exact !important;           /* Firefox 97+, Safari 15.4+ */
  }
`

const PhoneNumber = styled.div`
  font-size: 18px;
  @media (max-width: 600px) {
    font-size: 14px;
    padding-left: 25px;
  }
`

const PhoneInfo = styled.div`
  font-size: 11px;
`

const BookingButton = styled.div`
  ${ButtonStyles};
  color: ${(props) => props.theme.greenColor};
  font-size: 16px;
  background: lightgrey;
  background: ${(props) => props.theme.darkBlueColor}
    url('${Utils.getAssetPath('/assets/calculator/result/calendar.svg')}') no-repeat 10px center;
  background-size: 30px;
  text-align: right;
  padding-right: 30px;
  border-radius: 5px;
  padding-top: 13px;
   @media (max-width: 600px) {
   font-size: 11px;
   padding-left: 31px;
   text-align: left;
   padding-right: 0;
   border-radius: 0 5px 5px 0;
   background-size: 20px;
   background-position: 3px center;
   padding-top: 12px;
   margin-top: 0;
   height: 36px;
   }
  @media print { 
  display: none;
  }
`
